import { render, staticRenderFns } from "./EsyFigcaption.vue?vue&type=template&id=46c43a75&scoped=true"
import script from "./EsyFigcaption.vue?vue&type=script&lang=ts"
export * from "./EsyFigcaption.vue?vue&type=script&lang=ts"
import style0 from "./EsyFigcaption.vue?vue&type=style&index=0&id=46c43a75&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c43a75",
  null
  
)

export default component.exports